/**
 * Opens a Teams authentication pop-up window with a login page
 * for Office 365 Collaboration Service user authentication
 *
 * @param {string} redirect URL to redirect pop-up page to
 * @returns {Promise} A boolean that indicates if login was successful
 */
export const openO365LoginPopup = async (redirect: string) => {
  let resolve: (value: boolean | PromiseLike<boolean>) => void;
  const promise = new Promise<boolean>(res => (resolve = res));

  const url = new URL(redirect);

  // To close a pop-up without using Postmate, we need to be
  // redirected to '/externalAuthenticationReply' endpoint
  const state = JSON.parse(url.searchParams.get('state') ?? '');
  state.Referrer = `${window.location.origin}/externalAuthenticationReply`;
  url.searchParams.set('state', JSON.stringify(state));

  microsoftTeams.authentication.authenticate({
    height: 600,
    url: `/home/authorizeExternal?authUrl=${encodeURIComponent(
      url.toString()
    )}`,
    successCallback: result => resolve(true),
    failureCallback: reason => resolve(false),
  });

  return promise;
};
